export const amazonpayConstants = {
    GET_AMAZONPAY_CONFIGURATIONS_REQUEST: "GET_AMAZONPAY_CONFIGURATIONS_REQUEST",
    GET_AMAZONPAY_CONFIGURATIONS_SUCCESS: "GET_AMAZONPAY_CONFIGURATIONS_SUCCESS",
    GET_AMAZONPAY_CONFIGURATIONS_FAILURE: "GET_AMAZONPAY_CONFIGURATIONS_FAILURE",

    ADD_AMAZONPAY_CONFIGURATION_REQUEST: "ADD_AMAZONPAY_CONFIGURATION_REQUEST",
    ADD_AMAZONPAY_CONFIGURATION_SUCCESS: "ADD_AMAZONPAY_CONFIGURATION_SUCCESS",
    ADD_AMAZONPAY_CONFIGURATION_FAILURE: "ADD_AMAZONPAY_CONFIGURATION_FAILURE",

    UPDATE_AMAZONPAY_CONFIGURATION_REQUEST: "UPDATE_AMAZONPAY_CONFIGURATION_REQUEST",
    UPDATE_AMAZONPAY_CONFIGURATION_SUCCESS: "UPDATE_AMAZONPAY_CONFIGURATION_SUCCESS",
    UPDATE_AMAZONPAY_CONFIGURATION_FAILURE: "UPDATE_AMAZONPAY_CONFIGURATION_FAILURE",

    DELETE_AMAZONPAY_CONFIGURATION_REQUEST: "DELETE_AMAZONPAY_CONFIGURATION_REQUEST",
    DELETE_AMAZONPAY_CONFIGURATION_SUCCESS: "DELETE_AMAZONPAY_CONFIGURATION_SUCCESS",
    DELETE_AMAZONPAY_CONFIGURATION_FAILURE: "DELETE_AMAZONPAY_CONFIGURATION_FAILURE",

    TOGGLE_EDIT_CONFIGURATION_MODAL: "TOGGLE_EDIT_CONFIGURATION_MODAL",
    TOGGLE_DELETE_CONFIGURATION_MODAL: "TOGGLE_DELETE_CONFIGURATION_MODAL",

    TOGGLE_AMAZONPAY_IMPORT_MODAL: "TOGGLE_AMAZONPAY_IMPORT_MODAL",
    UPLOAD_AMAZONPAY_DATA_FILE_REQUEST: "UPLOAD_AMAZONPAY_DATA_FILE_REQUEST",
    UPLOAD_AMAZONPAY_DATA_FILE_SUCCESS: "UPLOAD_AMAZONPAY_DATA_FILE_SUCCESS",
    UPLOAD_AMAZONPAY_DATA_FILE_FAILURE: "UPLOAD_AMAZONPAY_DATA_FILE_FAILURE",

    RESET_STATE: "RESET_STATE",

    MIGRATE_CONFIGURATION_TO_V2_REQUEST: "MIGRATE_CONFIGURATION_TO_V2_REQUEST",
    MIGRATE_CONFIGURATION_TO_V2_SUCCESS: "MIGRATE_CONFIGURATION_TO_V2_SUCCESS",
    MIGRATE_CONFIGURATION_TO_V2_FAILURE: "MIGRATE_CONFIGURATION_TO_V2_FAILURE",

    LOAD_AMAZONPAY_MIGRATION_MODAL: "LOAD_AMAZONPAY_MIGRATION_MODAL",

    SET_CONFIGURATION_AND_CLIENT_TO_MIGRATE: "SET_CONFIGURATION_AND_CLIENT_TO_MIGRATE",

    SET_TRANSIT_ACCOUNT_MESSAGE: "SET_TRANSIT_ACCOUNT_MESSAGE",

    SET_HOLDING_ACCOUNT_MESSAGE: "SET_HOLDING_ACCOUNT_MESSAGE",

    UPDATE_VALUE_ON_CONFIGURATION: "UPDATE_VALUE_ON_CONFIGURATION",
};
